import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class CardUnlinkedFromIntegrationTool extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'CardUnlinkedFromIntegrationTool';

    public constructor(public cardId: string, public statusKey?: number, public releaseViewOrder?: number) {
        super(CardUnlinkedFromIntegrationTool.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: CardUnlinkedFromIntegrationTool): void => {
    const card = [...state.activities, ...state.tasks, ...state.subtasks].find((x) => x.id === action.cardId);

    if (!card) {
        return;
    }

    card.isLinkedToIntegrationTool = false;
    card.linkedUrl = '';
    card.linkedItemKey = '';
    card.linkedItemTypeId = null;
    card.linkedItemTypeName = null;

    if (action.statusKey != null) {
        const subtask = state.subtasks.find((x) => x.id === action.cardId);
        if (subtask) {
            subtask.status = action.statusKey;
            subtask.releaseViewOrder = action.releaseViewOrder ?? null;
        }
    }
};

//@ts-ignore
registerReducer(CardUnlinkedFromIntegrationTool.ACTION_TYPE, reducer);
